// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__24DnH","title":"FrontImage_title__14lQR"};